// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd991a3e","389":"b8838825","455":"59bc4d4a","488":"3468197e"}[chunkId] + ".chunk.js";
};